export const mockComps = [
  {
    propertyId: 'c1',
    score: 85,
    address: { street: '10425 Old Mill Creek Rd', city: 'Denver', state: 'CO', zip: '80202' },
    specs: { beds: 3, baths: 2, sqft: 1850 },
    year_built: 1974,
    status: 'Sold',
    price: 265000,
    sold_price: 265000,
    adjusted_price: 285500,
    list_date: '2025-01-10',
    last_sold_date: '2025-06-28',
    distanceSubj: 0.35,
    dom: 48,
    listingCoord: { lat: 39.742, lng: -104.988 },
    photos: [],
    archived: false,
  },
  {
    propertyId: 'c2',
    score: 82,
    address: { street: '4820 Birchwood Ct', city: 'Denver', state: 'CO', zip: '80204' },
    specs: { beds: 3, baths: 2, sqft: 1780 },
    year_built: 1978,
    status: 'Sold',
    price: 258000,
    sold_price: 258000,
    adjusted_price: 272000,
    list_date: '2025-02-03',
    last_sold_date: '2025-05-15',
    distanceSubj: 0.52,
    dom: 61,
    listingCoord: { lat: 39.739, lng: -104.992 },
    photos: [],
    archived: false,
  },
  {
    propertyId: 'c3',
    score: 79,
    address: { street: '3317 Elmwood Ave', city: 'Denver', state: 'CO', zip: '80206' },
    specs: { beds: 4, baths: 2, sqft: 2100 },
    year_built: 1969,
    status: 'Sold',
    price: 310000,
    sold_price: 310000,
    adjusted_price: 298000,
    list_date: '2024-12-18',
    last_sold_date: '2025-04-02',
    distanceSubj: 0.78,
    dom: 35,
    listingCoord: { lat: 39.745, lng: -104.979 },
    photos: [],
    archived: false,
  },
  {
    propertyId: 'c4',
    score: 76,
    address: { street: '701 Maple St', city: 'Denver', state: 'CO', zip: '80203' },
    specs: { beds: 3, baths: 1, sqft: 1640 },
    year_built: 1982,
    status: 'Active',
    price: 249000,
    sold_price: null,
    adjusted_price: 255000,
    list_date: '2025-04-20',
    last_sold_date: null,
    distanceSubj: 0.91,
    dom: 22,
    listingCoord: { lat: 39.737, lng: -104.984 },
    photos: [],
    archived: false,
  },
  {
    propertyId: 'c5',
    score: 74,
    address: { street: '2256 Spruce Ln', city: 'Denver', state: 'CO', zip: '80207' },
    specs: { beds: 3, baths: 2, sqft: 1920 },
    year_built: 1976,
    status: 'Sold',
    price: 278000,
    sold_price: 278000,
    adjusted_price: 281500,
    list_date: '2024-11-05',
    last_sold_date: '2025-03-10',
    distanceSubj: 1.1,
    dom: 54,
    listingCoord: { lat: 39.748, lng: -104.975 },
    photos: [],
    archived: false,
  },
  {
    propertyId: 'c6',
    score: 71,
    address: { street: '5580 Cedar Ridge Dr', city: 'Denver', state: 'CO', zip: '80209' },
    specs: { beds: 4, baths: 3, sqft: 2280 },
    year_built: 1971,
    status: 'Active',
    price: 335000,
    sold_price: null,
    adjusted_price: 320000,
    list_date: '2025-03-15',
    last_sold_date: null,
    distanceSubj: 1.3,
    dom: 18,
    listingCoord: { lat: 39.733, lng: -104.981 },
    photos: [],
    archived: false,
  },
]

const example = {
    "data": {
        "arv": {
            "criteria": {
                "propertyType": null,
                "beds": 3,
                "baths": 2,
                "sqftMin": 1208,
                "sqftMax": null,
                "yearBuiltMin": 1992,
                "radiusMiles": 1
            },
            "estimate": {
                "avgPricePerSqft": 257.81,
                "adjustedArv": 366352,
                "compCount": 17
            },
            "searchedAt": "2026-05-17T08:07:51.251Z",
            "comps": [
                {
                    "propertyId": "731-E-Reflection-Pl,-Chandler,-AZ-85286",
                    "score": 0,
                    "year_built": 2003,
                    "adjusted_price": 0,
                    "status": "Inactive",
                    "price": 519000,
                    "list_date": "2026-04-07T00:00:00.000Z",
                    "list_price": 519000,
                    "sold_price": null,
                    "specs": {
                        "beds": 3,
                        "baths": 2.5,
                        "sqft": 2195
                    },
                    "address": {
                        "street": "731 E Reflection Pl",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85286",
                        "formattedAddress": "731 E Reflection Pl, Chandler, AZ 85286"
                    },
                    "glyphLabel": "519K",
                    "lot_size": 0.08264462809917356,
                    "last_sold_date": "2026-05-10T00:00:00.000Z",
                    "distanceSubj": 0.45,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2026-04-07",
                            "event": "Sale Listing",
                            "price": 519000,
                            "daysOnMarket": 33
                        }
                    ],
                    "dom": 33,
                    "hoa": 157,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.284672,
                        "lon": -111.829841
                    },
                    "photos": [],
                    "adjustments": 424700
                },
                {
                    "propertyId": "1146-E-Winchester-Pl,-Chandler,-AZ-85286",
                    "score": 0,
                    "year_built": 2002,
                    "adjusted_price": 0,
                    "status": "Inactive",
                    "price": 683000,
                    "list_date": "2026-04-04T00:00:00.000Z",
                    "list_price": 683000,
                    "sold_price": null,
                    "specs": {
                        "beds": 5,
                        "baths": 3,
                        "sqft": 3083
                    },
                    "address": {
                        "street": "1146 E Winchester Pl",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85286",
                        "formattedAddress": "1146 E Winchester Pl, Chandler, AZ 85286"
                    },
                    "glyphLabel": "683K",
                    "lot_size": 0.20498163452708906,
                    "last_sold_date": "2026-05-09T00:00:00.000Z",
                    "distanceSubj": 0.54,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2025-12-19",
                            "event": "Sale Listing",
                            "price": 685000,
                            "daysOnMarket": 36
                        },
                        {
                            "date": "2026-04-04",
                            "event": "Sale Listing",
                            "price": 683000,
                            "daysOnMarket": 35
                        }
                    ],
                    "dom": 35,
                    "hoa": 96,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.288492,
                        "lon": -111.821611
                    },
                    "photos": [],
                    "adjustments": 417300
                },
                {
                    "propertyId": "67-E-Kesler-Ln,-Chandler,-AZ-85225",
                    "score": 0,
                    "year_built": 1984,
                    "adjusted_price": 0,
                    "status": "Inactive",
                    "price": 360000,
                    "list_date": "2026-05-05T00:00:00.000Z",
                    "list_price": 360000,
                    "sold_price": null,
                    "specs": {
                        "beds": 3,
                        "baths": 2,
                        "sqft": 998
                    },
                    "address": {
                        "street": "67 E Kesler Ln",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85225",
                        "formattedAddress": "67 E Kesler Ln, Chandler, AZ 85225"
                    },
                    "glyphLabel": "360K",
                    "lot_size": 0.1890036730945822,
                    "last_sold_date": "2026-05-08T00:00:00.000Z",
                    "distanceSubj": 0.57,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2026-05-05",
                            "event": "Sale Listing",
                            "price": 360000,
                            "daysOnMarket": 3
                        }
                    ],
                    "dom": 3,
                    "hoa": null,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.291945,
                        "lon": -111.840157
                    },
                    "photos": [],
                    "adjustments": 389400
                },
                {
                    "propertyId": "921-E-Folley-St,-Chandler,-AZ-85225",
                    "score": 0,
                    "year_built": 1994,
                    "adjusted_price": 0,
                    "status": "Inactive",
                    "price": 459900,
                    "list_date": "2026-04-02T00:00:00.000Z",
                    "list_price": 459900,
                    "sold_price": null,
                    "specs": {
                        "beds": 3,
                        "baths": 2,
                        "sqft": 1208
                    },
                    "address": {
                        "street": "921 E Folley St",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85225",
                        "formattedAddress": "921 E Folley St, Chandler, AZ 85225"
                    },
                    "glyphLabel": "459.9K",
                    "lot_size": 0.11430211202938476,
                    "last_sold_date": "2026-05-07T00:00:00.000Z",
                    "distanceSubj": 0.54,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2026-04-02",
                            "event": "Sale Listing",
                            "price": 459900,
                            "daysOnMarket": 35
                        }
                    ],
                    "dom": 35,
                    "hoa": 35,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.298218,
                        "lon": -111.825951
                    },
                    "photos": [],
                    "adjustments": 478500
                },
                {
                    "propertyId": "1310-E-Springfield-Pl,-Chandler,-AZ-85286",
                    "score": 0,
                    "year_built": 2020,
                    "adjusted_price": 0,
                    "status": "Inactive",
                    "price": 697500,
                    "list_date": "2026-02-12T00:00:00.000Z",
                    "list_price": 697500,
                    "sold_price": null,
                    "specs": {
                        "beds": 4,
                        "baths": 3,
                        "sqft": 2502
                    },
                    "address": {
                        "street": "1310 E Springfield Pl",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85286",
                        "formattedAddress": "1310 E Springfield Pl, Chandler, AZ 85286"
                    },
                    "glyphLabel": "697.5K",
                    "lot_size": 0.09182736455463728,
                    "last_sold_date": "2026-05-02T00:00:00.000Z",
                    "distanceSubj": 0.65,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2026-02-12",
                            "event": "Sale Listing",
                            "price": 697500,
                            "daysOnMarket": 79
                        }
                    ],
                    "dom": 79,
                    "hoa": 188,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.29085,
                        "lon": -111.819085
                    },
                    "photos": [],
                    "adjustments": 518300
                },
                {
                    "propertyId": "386-W-Fairview-St,-Chandler,-AZ-85225",
                    "score": 0,
                    "year_built": 1948,
                    "adjusted_price": 0,
                    "status": "Inactive",
                    "price": 499900,
                    "list_date": "2026-03-28T00:00:00.000Z",
                    "list_price": 499900,
                    "sold_price": null,
                    "specs": {
                        "beds": 2,
                        "baths": 1,
                        "sqft": 900
                    },
                    "address": {
                        "street": "386 W Fairview St",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85225",
                        "formattedAddress": "386 W Fairview St, Chandler, AZ 85225"
                    },
                    "glyphLabel": "499.9K",
                    "lot_size": 0.1,
                    "last_sold_date": "2026-05-01T00:00:00.000Z",
                    "distanceSubj": 0.93,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2026-03-28",
                            "event": "Sale Listing",
                            "price": 499900,
                            "daysOnMarket": 34
                        }
                    ],
                    "dom": 34,
                    "hoa": null,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.295439,
                        "lon": -111.845561
                    },
                    "photos": [],
                    "adjustments": 565400
                },
                {
                    "propertyId": "600-S-Velero-St,-Chandler,-AZ-85225",
                    "score": 0,
                    "year_built": 1985,
                    "adjusted_price": 0,
                    "status": "Inactive",
                    "price": 495000,
                    "list_date": "2025-10-24T00:00:00.000Z",
                    "list_price": 495000,
                    "sold_price": null,
                    "specs": {
                        "beds": 3,
                        "baths": 2,
                        "sqft": 1293
                    },
                    "address": {
                        "street": "600 S Velero St",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85225",
                        "formattedAddress": "600 S Velero St, Chandler, AZ 85225"
                    },
                    "glyphLabel": "495K",
                    "lot_size": 0.21239669421487603,
                    "last_sold_date": "2026-04-25T00:00:00.000Z",
                    "distanceSubj": 0.91,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2025-10-24",
                            "event": "Sale Listing",
                            "price": 495000,
                            "daysOnMarket": 183
                        }
                    ],
                    "dom": 183,
                    "hoa": null,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.295715,
                        "lon": -111.815428
                    },
                    "photos": [],
                    "adjustments": 504200
                },
                {
                    "propertyId": "1192-E-Springfield-Pl,-Chandler,-AZ-85286",
                    "score": 0,
                    "year_built": 2002,
                    "adjusted_price": 0,
                    "status": "Inactive",
                    "price": 650000,
                    "list_date": "2026-04-21T00:00:00.000Z",
                    "list_price": 650000,
                    "sold_price": null,
                    "specs": {
                        "beds": 4,
                        "baths": 3,
                        "sqft": 2342
                    },
                    "address": {
                        "street": "1192 E Springfield Pl",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85286",
                        "formattedAddress": "1192 E Springfield Pl, Chandler, AZ 85286"
                    },
                    "glyphLabel": "650K",
                    "lot_size": 0.19559228650137742,
                    "last_sold_date": "2026-04-25T00:00:00.000Z",
                    "distanceSubj": 0.55,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2026-04-21",
                            "event": "Sale Listing",
                            "price": 650000,
                            "daysOnMarket": 4
                        }
                    ],
                    "dom": 4,
                    "hoa": 96,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.290503,
                        "lon": -111.82073
                    },
                    "photos": [],
                    "adjustments": 502300
                },
                {
                    "propertyId": "807-E-Morelos-St,-Chandler,-AZ-85225",
                    "score": 0,
                    "year_built": 1995,
                    "adjusted_price": 0,
                    "status": "Inactive",
                    "price": 532000,
                    "list_date": "2026-03-26T00:00:00.000Z",
                    "list_price": 532000,
                    "sold_price": null,
                    "specs": {
                        "beds": 3,
                        "baths": 2.5,
                        "sqft": 2250
                    },
                    "address": {
                        "street": "807 E Morelos St",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85225",
                        "formattedAddress": "807 E Morelos St, Chandler, AZ 85225"
                    },
                    "glyphLabel": "532K",
                    "lot_size": 0.14439853076216713,
                    "last_sold_date": "2026-04-22T00:00:00.000Z",
                    "distanceSubj": 0.21,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2026-03-26",
                            "event": "Sale Listing",
                            "price": 532000,
                            "daysOnMarket": 27
                        }
                    ],
                    "dom": 27,
                    "hoa": 44,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.293979,
                        "lon": -111.828707
                    },
                    "photos": [],
                    "adjustments": 427800
                },
                {
                    "propertyId": "876-S-Nebraska-St,-Unit-9,-Chandler,-AZ-85225",
                    "score": 0,
                    "year_built": 1986,
                    "adjusted_price": 0,
                    "status": "Active",
                    "price": 328000,
                    "list_date": "2026-03-03T00:00:00.000Z",
                    "list_price": 328000,
                    "sold_price": null,
                    "specs": {
                        "beds": 3,
                        "baths": 2,
                        "sqft": 1116
                    },
                    "address": {
                        "street": "876 S Nebraska St",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85225",
                        "formattedAddress": "876 S Nebraska St, Unit 9, Chandler, AZ 85225"
                    },
                    "glyphLabel": "328K",
                    "lot_size": 0.037809917355371904,
                    "last_sold_date": null,
                    "distanceSubj": 0.99,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2026-03-03",
                            "event": "Sale Listing",
                            "price": 328000,
                            "daysOnMarket": 75
                        }
                    ],
                    "dom": 75,
                    "hoa": 107,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.291931,
                        "lon": -111.847324
                    },
                    "photos": [],
                    "adjustments": 348600
                },
                {
                    "propertyId": "288-S-Jesse-St,-Chandler,-AZ-85225",
                    "score": 0,
                    "year_built": 1995,
                    "adjusted_price": 0,
                    "status": "Active",
                    "price": 635000,
                    "list_date": "2026-02-27T00:00:00.000Z",
                    "list_price": 635000,
                    "sold_price": null,
                    "specs": {
                        "beds": 4,
                        "baths": 3,
                        "sqft": 2049
                    },
                    "address": {
                        "street": "288 S Jesse St",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85225",
                        "formattedAddress": "288 S Jesse St, Chandler, AZ 85225"
                    },
                    "glyphLabel": "635K",
                    "lot_size": 0.14506427915518824,
                    "last_sold_date": null,
                    "distanceSubj": 0.72,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2026-02-27",
                            "event": "Sale Listing",
                            "price": 635000,
                            "daysOnMarket": 79
                        }
                    ],
                    "dom": 79,
                    "hoa": 120,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.2996,
                        "lon": -111.82282
                    },
                    "photos": [],
                    "adjustments": 531300
                },
                {
                    "propertyId": "800-S-Bedford-Dr,-Chandler,-AZ-85225",
                    "score": 0,
                    "year_built": 1999,
                    "adjusted_price": 0,
                    "status": "Active",
                    "price": 450000,
                    "list_date": "2026-02-13T00:00:00.000Z",
                    "list_price": 450000,
                    "sold_price": null,
                    "specs": {
                        "beds": 4,
                        "baths": 2.5,
                        "sqft": 1728
                    },
                    "address": {
                        "street": "800 S Bedford Dr",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85225",
                        "formattedAddress": "800 S Bedford Dr, Chandler, AZ 85225"
                    },
                    "glyphLabel": "450K",
                    "lot_size": 0.07231404958677685,
                    "last_sold_date": null,
                    "distanceSubj": 0.47,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2026-02-13",
                            "event": "Sale Listing",
                            "price": 450000,
                            "daysOnMarket": 93
                        }
                    ],
                    "dom": 93,
                    "hoa": 181,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.293841,
                        "lon": -111.822701
                    },
                    "photos": [],
                    "adjustments": 408300
                },
                {
                    "propertyId": "821-E-Kesler-Ln,-Chandler,-AZ-85225",
                    "score": 0,
                    "year_built": 1995,
                    "adjusted_price": 0,
                    "status": "Active",
                    "price": 559000,
                    "list_date": "2026-02-05T00:00:00.000Z",
                    "list_price": 559000,
                    "sold_price": null,
                    "specs": {
                        "beds": 4,
                        "baths": 3,
                        "sqft": 2167
                    },
                    "address": {
                        "street": "821 E Kesler Ln",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85225",
                        "formattedAddress": "821 E Kesler Ln, Chandler, AZ 85225"
                    },
                    "glyphLabel": "559K",
                    "lot_size": 0.14320477502295684,
                    "last_sold_date": null,
                    "distanceSubj": 0.15,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2026-02-05",
                            "event": "Sale Listing",
                            "price": 559000,
                            "daysOnMarket": 101
                        }
                    ],
                    "dom": 101,
                    "hoa": 44,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.292359,
                        "lon": -111.828006
                    },
                    "photos": [],
                    "adjustments": 453800
                },
                {
                    "propertyId": "1014-S-Mosley-Dr,-Chandler,-AZ-85286",
                    "score": 0,
                    "year_built": 2002,
                    "adjusted_price": 0,
                    "status": "Active",
                    "price": 482000,
                    "list_date": "2026-04-30T00:00:00.000Z",
                    "list_price": 482000,
                    "sold_price": null,
                    "specs": {
                        "beds": 3,
                        "baths": 2.5,
                        "sqft": 2195
                    },
                    "address": {
                        "street": "1014 S Mosley Dr",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85286",
                        "formattedAddress": "1014 S Mosley Dr, Chandler, AZ 85286"
                    },
                    "glyphLabel": "482K",
                    "lot_size": 0.08666207529843893,
                    "last_sold_date": null,
                    "distanceSubj": 0.05,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2026-04-30",
                            "event": "Sale Listing",
                            "price": 482000,
                            "daysOnMarket": 17
                        }
                    ],
                    "dom": 17,
                    "hoa": 154,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.291229,
                        "lon": -111.831191
                    },
                    "photos": [],
                    "adjustments": 394300
                },
                {
                    "propertyId": "857-E-Buffalo-St,-Chandler,-AZ-85225",
                    "score": 0,
                    "year_built": 1962,
                    "adjusted_price": 0,
                    "status": "Active",
                    "price": 440000,
                    "list_date": "2025-12-01T00:00:00.000Z",
                    "list_price": 440000,
                    "sold_price": null,
                    "specs": {
                        "beds": 4,
                        "baths": 2,
                        "sqft": 1683
                    },
                    "address": {
                        "street": "857 E Buffalo St",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85225",
                        "formattedAddress": "857 E Buffalo St, Chandler, AZ 85225"
                    },
                    "glyphLabel": "440K",
                    "lot_size": 0.15670339761248853,
                    "last_sold_date": null,
                    "distanceSubj": 0.94,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2025-12-01",
                            "event": "Sale Listing",
                            "price": 440000,
                            "daysOnMarket": 167
                        }
                    ],
                    "dom": 167,
                    "hoa": null,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.304482,
                        "lon": -111.826975
                    },
                    "photos": [],
                    "adjustments": 408500
                },
                {
                    "propertyId": "770-S-Crosscreek-Pl,-Chandler,-AZ-85225",
                    "score": 0,
                    "year_built": 2001,
                    "adjusted_price": 0,
                    "status": "Active",
                    "price": 730000,
                    "list_date": "2026-05-13T00:00:00.000Z",
                    "list_price": 730000,
                    "sold_price": null,
                    "specs": {
                        "beds": 5,
                        "baths": 3.5,
                        "sqft": 3862
                    },
                    "address": {
                        "street": "770 S Crosscreek Pl",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85225",
                        "formattedAddress": "770 S Crosscreek Pl, Chandler, AZ 85225"
                    },
                    "glyphLabel": "730K",
                    "lot_size": 0.2255050505050505,
                    "last_sold_date": null,
                    "distanceSubj": 0.55,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2025-12-31",
                            "event": "Sale Listing",
                            "price": 750000,
                            "daysOnMarket": 93
                        },
                        {
                            "date": "2026-05-13",
                            "event": "Sale Listing",
                            "price": 730000,
                            "daysOnMarket": 4
                        }
                    ],
                    "dom": 4,
                    "hoa": 73,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.294205,
                        "lon": -111.821379
                    },
                    "photos": [],
                    "adjustments": 325300
                },
                {
                    "propertyId": "1171-E-Springfield-Pl,-Chandler,-AZ-85286",
                    "score": 0,
                    "year_built": 2003,
                    "adjusted_price": 0,
                    "status": "Active",
                    "price": 775000,
                    "list_date": "2026-05-14T00:00:00.000Z",
                    "list_price": 775000,
                    "sold_price": null,
                    "specs": {
                        "beds": 6,
                        "baths": 4.5,
                        "sqft": 3512
                    },
                    "address": {
                        "street": "1171 E Springfield Pl",
                        "city": "Chandler",
                        "state": "AZ",
                        "zip": "85286",
                        "formattedAddress": "1171 E Springfield Pl, Chandler, AZ 85286"
                    },
                    "glyphLabel": "775K",
                    "lot_size": 0.19559228650137742,
                    "last_sold_date": null,
                    "distanceSubj": 0.53,
                    "parking_spaces": null,
                    "history": [
                        {
                            "date": "2026-05-14",
                            "event": "Sale Listing",
                            "price": 775000,
                            "daysOnMarket": 3
                        }
                    ],
                    "dom": 3,
                    "hoa": 96,
                    "elementary_school": null,
                    "middle_school": null,
                    "high_school": null,
                    "high_school_score": null,
                    "middle_school_score": null,
                    "elementary_school_score": null,
                    "total_tax": null,
                    "total_assessment": null,
                    "assessment_year": null,
                    "flood_zone": null,
                    "descriptionText": null,
                    "archived": false,
                    "listingCoord": {
                        "lat": 33.290053,
                        "lon": -111.821178
                    },
                    "photos": [],
                    "adjustments": 399700
                }
            ]
        }
    }
}
